<template>
  <v-app :class="{ 'mobile-app': isApple }">
    <v-app-bar absolute app dense color="amber">
      <v-toolbar-title>Beer Finder</v-toolbar-title>

      <v-spacer />

      <v-btn text small @click="showAddInfoModal">
        <v-icon class="mr-1">mdi-plus-circle</v-icon> Добавить
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view />

      <google-map @click="openCreatingModal" />

      <place-create
        v-if="isCreationModalOpen"
        :lat="position.lat"
        :lng="position.lng"
        @close="closeCreatingModal"
      />

      <place-add-info v-if="isAddInfoModalOpen" @close="disableAddMode" @confirm="enableAddMode" />

      <v-alert
        v-if="isAddMode"
        class="mx-5 my-5"
        dense
        dismissible
        transition="scale-transition"
        border="left"
        elevation="5"
        colored-border
        type="warning"
      >
        Вы находитесь в режиме добавления заведения. Кликните на карте в том месте, где находится
        заведение.
      </v-alert>
    </v-content>

    <v-footer app>
      <v-switch
        :input-value="isAddModeEnable"
        dense
        hide-details
        label="Режим добавления"
        class="my-0 py-0"
        @change="addModeToggle"
      />

      <v-spacer></v-spacer>

      <!--
      <a href="https://www.facebook.com/finder.beer" target="_blank" class="mr-2">
        <v-icon>mdi-facebook</v-icon>
      </a>

      <a href="https://www.instagram.com/finder.beer/" target="_blank" class="mr-2">
        <v-icon>mdi-instagram</v-icon>
      </a>
      -->

      <a href="https://vk.com/finder.beer" target="_blank" class="mr-2">
        <v-icon>mdi-vk</v-icon>
      </a>
    </v-footer>
  </v-app>
</template>

<script>
import MobileDetect from 'mobile-detect';
import { mapGetters } from 'vuex';
import GoogleMap from '@/components/GoogleMap';
import placeCreate from '@/components/place/Create';
import PlaceAddInfo from '@/components/place/CreateBlank';

export default {
  name: `App`,

  components: {
    GoogleMap,
    placeCreate,
    PlaceAddInfo,
  },

  data() {
    return {
      isAddMode: false,
      isCreationModalOpen: false,
      isAddInfoModalOpen: false,

      position: {
        lat: 0,
        lng: 0,
      },
    };
  },

  computed: {
    ...mapGetters(['isAddModeEnable']),

    isApple() {
      if (process.env.NODE_ENV !== 'production') {
        return false;
      }

      const md = new MobileDetect(window.navigator.userAgent);
      const os = md.os() || '';
      return os.toLowerCase() === 'ios';
    },
  },

  methods: {
    addModeToggle(value) {
      if (value) {
        this.enableAddMode();
      } else {
        this.disableAddMode();
      }
    },

    enableAddMode() {
      this.$store.dispatch('map/enableAddMode');
      this.isAddInfoModalOpen = false;
    },

    disableAddMode() {
      this.$store.dispatch('map/disableAddMode');
      this.isAddInfoModalOpen = false;
    },

    openCreatingModal(position) {
      this.position = position;
      this.isCreationModalOpen = true;
    },

    closeCreatingModal() {
      this.isCreationModalOpen = false;
      this.isAddMode = false;
    },

    showAddInfoModal() {
      this.isAddInfoModalOpen = true;
    },

    hideAddInfoModal() {
      this.isAddInfoModalOpen = false;
    },
  },
};
</script>

<style lang="css">
.mobile-app .v-application--wrap {
  min-height: 100vh !important;
  min-height: -moz-available !important; /* WebKit игнор. */
  min-height: -webkit-fill-available !important; /* Mozilla игнор. */
  min-height: fill-available !important;
}

.v-footer a {
  text-decoration: none;
}

.v-footer .v-input__slot {
  margin-bottom: 0 !important;
}

.no-underline {
  text-decoration: none;
}

.v-dialog {
  z-index: 1000;
}
</style>
